import { render } from "./runPoints.vue?vue&type=template&id=0eb380ab&scoped=true"
import script from "./runPoints.vue?vue&type=script&lang=js"
export * from "./runPoints.vue?vue&type=script&lang=js"

import "./runPoints.vue?vue&type=style&index=0&id=0eb380ab&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eb380ab"]])

export default __exports__